import React, { LegacyRef } from 'react'
import styles from '../styles.css'
import { observer } from 'mobx-react'
import EpayTemplateStore from '../epay-template-store'
import { ColorScheme } from '../colors'
import res from '../res'
const FormPresentation = observer(({ cs, store, imageRef }: { cs: ColorScheme, store: EpayTemplateStore, imageRef: LegacyRef<HTMLImageElement> }) => {
    const buttonsColor = cs?.buttons
    const formBackground = cs?.bg?.gradient
    const cardBackground = cs?.card_bg?.gradient
    const textColor = cs?.text
    const cardTextColor = cs?.card_text
    return (
        <div
            className={styles.paymentForm}
            style={{
                background: formBackground,
                display: store.isError ? 'none' : ''
            }}
        >
            <div style={{ textAlign: 'center' }}>
                <img
                    ref={imageRef}
                    alt={'image'}
                    style={{
                        maxHeight: '45px',
                        maxWidth: '45px'
                    }}
                    src={store.assets.logo_url}
                />
                <div className={styles.paymentFormPad}>
                    <label style={{ color: textColor }}> {res().sampleForm.Order} #1234567890</label>
                </div>
                <div
                    className={styles.paymentFormPad}
                    style={{ fontSize: 'larger' }}
                >
                    <label style={{ color: textColor }}>100 KZT</label>
                </div>
                <div className={styles.paymentFormPad}>
                    <label style={{ color: buttonsColor }}>
                        {res().sampleForm.PaymentStore}
                    </label>
                </div>
                <div
                    className={styles.paymentFormPad}
                    style={{
                        width: '240px',
                        margin: '0 auto',
                        textAlign: 'left'
                    }}
                >
                    <label style={{ color: textColor }}>{res().sampleForm.Commission} </label>
                    <label style={{ color: buttonsColor }}> 0 KZT</label>
                </div>
                <div
                    className={styles.paymentFormPad}
                    style={{
                        width: '240px',
                        margin: '0 auto',
                        textAlign: 'left'
                    }}
                >
                    <label style={{ color: textColor }}>{res().sampleForm.Seller}</label>
                    <label style={{ color: buttonsColor }}>
                        {' '}
                        {store.shopName.value}
                    </label>
                </div>
                <div className={styles.paymentTypeContainer}>
                    <div
                        className={styles.paymentType}
                        style={{
                            border: `2px solid ${buttonsColor}`,
                            backgroundColor: 'none'
                        }}
                    >
                        <svg
                            width="25"
                            height="25"
                            viewBox="0 0 25 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M24.3805 7.16535L17.8353 0.620079C17.0085 -0.206693 15.665 -0.206693 14.8382 0.620079L3.95238 11.5157H2.11675C0.950414 11.5157 0.000610352 12.4656 0.000610352 13.6319V22.8839C0.000610352 24.0502 0.950414 25 2.11675 25H17.0971C18.2634 25 19.2132 24.0502 19.2132 22.8839V15.3248L24.3756 10.1624C25.2073 9.33563 25.2073 7.99213 24.3805 7.16535ZM15.8225 1.60433C16.1079 1.3189 16.5705 1.3189 16.8559 1.60433L17.9878 2.73622L9.21321 11.5157H5.91104L15.8225 1.60433ZM1.38841 13.6319C1.38841 13.2283 1.71321 12.9035 2.11675 12.9035H17.0971C17.5006 12.9035 17.8254 13.2283 17.8254 13.6319V15.2362H1.38841V13.6319ZM17.8303 22.8888C17.8303 23.2923 17.5055 23.6171 17.102 23.6171H2.11675C1.71321 23.6171 1.38841 23.2923 1.38841 22.8888V16.624H17.8303V22.8888ZM23.4012 9.18307L19.2034 13.3809C19.0754 12.3327 18.1847 11.5157 17.102 11.5157H11.1817L18.9721 3.72047L23.4012 8.14961C23.6817 8.43504 23.6817 8.89764 23.4012 9.18307Z"
                                fill={buttonsColor}
                            />
                        </svg>
                    </div>
                    <div
                        className={styles.paymentType}
                        style={{
                            borderColor: buttonsColor,
                            opacity: 0.5
                        }}
                    >
                        <svg
                            width="44"
                            height="21"
                            viewBox="0 0 44 21"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M11.2775 8.6972C11.3007 11.1744 13.4773 11.9986 13.5014 12.0092C13.4831 12.0677 13.1538 13.1841 12.3552 14.3378C11.6641 15.3348 10.9473 16.3284 9.81808 16.3492C8.70839 16.3695 8.35206 15.6995 7.08289 15.6995C5.81455 15.6995 5.41794 16.3284 4.36763 16.3695C3.27788 16.4102 2.44768 15.2908 1.75122 14.2971C0.327975 12.2642 -0.759706 8.55405 0.700917 6.04928C1.42645 4.80536 2.72262 4.01759 4.13008 3.99769C5.20032 3.97736 6.21075 4.7088 6.86527 4.7088C7.51896 4.7088 8.74701 3.82912 10.0382 3.9583C10.5781 3.98075 12.0948 4.17388 13.0687 5.58212C12.9898 5.6304 11.2584 6.62613 11.2775 8.6972ZM9.1918 2.61358C9.77032 1.92153 10.1603 0.958419 10.054 -0.000457764C9.21963 0.0325778 8.21085 0.54844 7.61282 1.24007C7.07624 1.8525 6.60695 2.83255 6.73362 3.77237C7.6639 3.84352 8.61328 3.30564 9.19221 2.61316L9.1918 2.61358ZM17.5681 1.42896C18.0393 1.34931 18.5127 1.28293 18.9876 1.2299C19.5548 1.16837 20.1249 1.13896 20.6953 1.14181C21.5824 1.14181 22.347 1.24854 22.9898 1.462C23.6336 1.67546 24.1614 1.98125 24.5751 2.37895C24.9332 2.73661 25.2163 3.16489 25.4069 3.63769C25.6063 4.12348 25.7051 4.68339 25.7051 5.31657C25.7051 6.08231 25.5693 6.75234 25.2956 7.32665C25.0326 7.88787 24.6501 8.38215 24.176 8.77344C23.7025 9.16309 23.141 9.45405 22.4907 9.64591C21.8399 9.83693 21.1305 9.93265 20.3614 9.93265C19.667 9.93265 19.0831 9.8814 18.6105 9.77848V16.1399H17.5681V1.42896ZM18.6105 8.85094C18.8617 8.92422 19.1425 8.97589 19.4531 9.00511C19.7638 9.03476 20.096 9.04916 20.4507 9.04916C21.7809 9.04916 22.8121 8.73998 23.5439 8.12162C24.2752 7.50326 24.6415 6.59733 24.6415 5.40466C24.6415 4.83035 24.5456 4.32931 24.3533 3.90239C24.1708 3.48787 23.8887 3.12703 23.5331 2.8533C23.1784 2.58055 22.7573 2.37471 22.2693 2.23452C21.7809 2.09476 21.2414 2.02487 20.6496 2.02487C20.177 2.02487 19.7704 2.04309 19.4303 2.07993C19.0906 2.11678 18.8169 2.15744 18.6101 2.20149V8.85094H18.6105ZM33.9954 13.6225C33.9954 14.0494 34.0025 14.4767 34.0174 14.9036C34.0319 15.3306 34.076 15.7422 34.1503 16.1404H33.1748L33.0198 14.6381H32.9746C32.8417 14.8448 32.6718 15.0506 32.465 15.2564C32.2582 15.4623 32.0181 15.6503 31.7449 15.8197C31.4712 15.9892 31.1609 16.1255 30.8133 16.2285C30.4417 16.3346 30.0572 16.3867 29.6713 16.383C29.1542 16.383 28.6994 16.2983 28.307 16.1289C27.9153 15.9595 27.5939 15.7389 27.3426 15.4665C27.0932 15.1964 26.9009 14.8768 26.7778 14.5275C26.6546 14.1882 26.5908 13.8293 26.5893 13.4674C26.5893 12.2159 27.1176 11.2515 28.1745 10.5739C29.2314 9.89622 30.8246 9.57222 32.9538 9.60187V9.31471C32.9538 9.03433 32.9277 8.71372 32.8762 8.35329C32.8242 7.99228 32.7075 7.64411 32.5319 7.32623C32.3545 7.00265 32.0887 6.73032 31.7341 6.50966C31.3794 6.28857 30.8985 6.17803 30.293 6.17803C29.8341 6.17803 29.3801 6.24791 28.9291 6.38768C28.4781 6.52745 28.0682 6.72227 27.6986 6.973L27.3659 6.19963C27.8385 5.87605 28.3269 5.64438 28.829 5.50462C29.3423 5.36342 29.8718 5.29291 30.4034 5.29497C31.1427 5.29497 31.7449 5.41991 32.2108 5.67022C32.6764 5.92052 33.0423 6.24453 33.3085 6.6418C33.5769 7.04498 33.7618 7.49983 33.8517 7.97847C33.9468 8.46208 33.9952 8.95404 33.9962 9.44728V13.6225H33.9954ZM32.953 10.4638C32.3644 10.4497 31.7756 10.4718 31.1896 10.5298C30.5766 10.5883 30.011 10.7179 29.4939 10.9161C28.976 11.1151 28.5479 11.4057 28.2081 11.7886C27.8684 12.1714 27.6977 12.6797 27.6977 13.3133C27.6977 14.0634 27.912 14.6161 28.3415 14.9693C28.7692 15.3225 29.2497 15.4996 29.7821 15.4996C30.2107 15.4996 30.5953 15.4411 30.935 15.3225C31.2752 15.2048 31.57 15.0464 31.8217 14.8482C32.0734 14.6499 32.2835 14.4246 32.4538 14.1747C32.6241 13.9236 32.7532 13.6665 32.8425 13.401C32.9164 13.1062 32.9538 12.8927 32.9538 12.7597V10.4638H32.953ZM36.0337 5.53723L38.7382 12.4289C38.889 12.819 39.0297 13.213 39.1601 13.6106C39.293 14.0155 39.4114 14.3878 39.5148 14.7262H39.5592C39.663 14.4026 39.781 14.0379 39.9139 13.6326C40.0472 13.2282 40.195 12.8118 40.3574 12.3841L42.8858 5.5368H43.9938L40.9123 13.3129C40.6301 14.0641 40.338 14.8114 40.036 15.5546C39.7871 16.1714 39.5097 16.7757 39.2045 17.3656C38.9503 17.859 38.6649 18.3351 38.3503 18.7908C38.0734 19.1903 37.7495 19.5537 37.3859 19.8729C36.9727 20.2406 36.5915 20.5099 36.2439 20.6794C35.8967 20.8488 35.6641 20.9555 35.5457 20.9995L35.1902 20.1381C35.4943 20.0005 35.7906 19.8457 36.0777 19.6743C36.4249 19.4656 36.7451 19.2133 37.0308 18.9234C37.2975 18.6583 37.5894 18.3093 37.9071 17.8739C38.2248 17.4398 38.5093 16.9133 38.761 16.2945C38.8495 16.059 38.8939 15.904 38.8939 15.8303C38.8939 15.7278 38.8499 15.5728 38.761 15.3666L34.9244 5.53638H36.0337V5.53723Z"
                                fill={buttonsColor}
                            />
                        </svg>
                    </div>
                    <div
                        className={styles.paymentType}
                        style={{
                            borderColor: buttonsColor,
                            opacity: 0.5
                        }}
                    >
                        <svg
                            width="17"
                            height="17"
                            viewBox="0 0 17 17"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M0 16.9999H7.72725V9.27261H0V16.9999ZM1.54533 10.8182H6.18175V15.4426H1.54533V10.8182Z"
                                fill={buttonsColor}
                            />
                            <path
                                d="M4.63632 12.3635H3.0909V13.9091H4.63632V12.3635Z"
                                fill={buttonsColor}
                            />
                            <path
                                d="M13.9091 15.4545H12.3633V17H13.9091V15.4545Z"
                                fill={buttonsColor}
                            />
                            <path
                                d="M16.9999 15.4545H15.4542V17H16.9999V15.4545Z"
                                fill={buttonsColor}
                            />
                            <path
                                d="M15.4544 10.8182H13.9091V9.27261H9.27254V16.9999H10.8181V12.3635H12.3633V13.9092H16.9999V9.27261H15.4544V10.8182Z"
                                fill={buttonsColor}
                            />
                            <path
                                d="M0 7.72742H7.72725V0H0V7.72742ZM1.54533 1.54533H6.18175V6.18175H1.54533V1.54533Z"
                                fill={buttonsColor}
                            />
                            <path
                                d="M4.63632 3.09082H3.0909V4.63636H4.63632V3.09082Z"
                                fill={buttonsColor}
                            />
                            <path
                                d="M9.27254 0V7.72742H17V0H9.27254ZM15.4544 6.18175H10.8181V1.54533H15.4544V6.18175Z"
                                fill={buttonsColor}
                            />
                            <path
                                d="M13.9091 3.09082H12.3633V4.63636H13.9091V3.09082Z"
                                fill={buttonsColor}
                            />
                        </svg>
                    </div>
                </div>

                <div className={styles.creditCardForm}>
                    <div
                        style={{
                            background: cardBackground,
                            margin: '10px 10px 10px 10px',
                            height: '150px',
                            borderRadius: '5px',
                            padding: '10px'
                        }}
                    >
                        <div>
                            <label
                                className={styles.cardFormLabel}
                                style={{ color: cardTextColor }}
                            >
                                {res().sampleForm.cardNumber}
                            </label>
                            <br />
                            <input
                                className={styles.cardFormInput}
                                style={{
                                    borderBottom: '1px solid ' + cardTextColor,
                                    color: cardTextColor
                                }}
                                type={'text'}
                                value="1234 5678 9012 345"
                                readOnly={true}
                            />
                        </div>
                        <div>
                            <div
                                style={{
                                    float: 'left',
                                    width: '70%'
                                }}
                            >
                                <label
                                    className={styles.cardFormLabel}
                                    style={{
                                        color: cardTextColor
                                    }}
                                >
                                    {res().sampleForm.expires}
                                </label>
                                <br />
                                <input
                                    className={styles.cardFormInput}
                                    style={{
                                        borderBottomColor: cardTextColor,
                                        color: cardTextColor,
                                        width: '25%'
                                    }}
                                    type={'text'}
                                    value="12"
                                    readOnly={true}
                                />
                                <label
                                    style={{
                                        color: cardTextColor
                                    }}
                                >
                                    /
                                </label>
                                <input
                                    className={styles.cardFormInput}
                                    style={{
                                        borderBottomColor: cardTextColor,
                                        color: cardTextColor,
                                        width: '25%'
                                    }}
                                    type={'text'}
                                    value="2021"
                                    readOnly={true}
                                />
                            </div>

                            <div style={{ float: 'right' }}>
                                <label
                                    className={styles.cardFormLabel}
                                    style={{
                                        color: cardTextColor
                                    }}
                                >
                                    CVV
                                </label>
                                <br />
                                <input
                                    size={5}
                                    className={styles.cardFormInput}
                                    style={{
                                        borderBottomColor: cardTextColor,
                                        color: cardTextColor
                                    }}
                                    type={'text'}
                                    value="****"
                                    readOnly={true}
                                />
                            </div>
                        </div>

                        <div style={{ clear: 'both' }}>
                            <label
                                className={styles.cardFormLabel}
                                style={{ color: cardTextColor }}
                            >
                                {res().sampleForm.cardName}
                            </label>
                            <br />
                            <input
                                className={styles.cardFormInput}
                                style={{
                                    borderBottomColor: cardTextColor,
                                    color: cardTextColor
                                }}
                                type={'text'}
                                value="Cardholder Name"
                                readOnly={true}
                            />
                        </div>
                    </div>
                    <div style={{ padding: '0px 10px 0px 10px' }}>
                        <label
                            className={styles.cardFormLabel}
                            style={{ color: textColor }}
                        >
                            {res().sampleForm.email}
                        </label>
                        <br />
                        <input
                            className={styles.cardFormInput}
                            style={{
                                borderBottomColor: textColor,
                                color: textColor
                            }}
                            value={'email@example.com'}
                            type={'text'}
                            readOnly={true}
                        />
                        <br />
                        <label
                            className={styles.cardFormLabel}
                            style={{ color: textColor }}
                        >
                            {res().sampleForm.phoneNumber}
                        </label>
                        <br />
                        <input
                            className={styles.cardFormInput}
                            style={{
                                borderBottomColor: textColor,
                                color: textColor
                            }}
                            value={'+71234567890'}
                            type={'text'}
                            readOnly={true}
                        />
                        <br />

                        <a
                            style={{
                                display: 'block',
                                marginTop: '15px',
                                color: cs?.bg?.color1,
                                backgroundColor: buttonsColor,
                                width: '100%',
                                height: '35px'
                            }}
                        >
                            <div
                                style={{
                                    paddingTop: '9px',
                                    textAlign: 'center'
                                }}
                            >
                                {res().sampleForm.pay}
                            </div>
                        </a>
                        <a
                            style={{
                                display: 'block',
                                marginTop: '10px',
                                border: '1px solid ' + buttonsColor,
                                color: buttonsColor,
                                backgroundColor: 'none',
                                width: '100%',
                                height: '35px'
                            }}
                        >
                            <div
                                style={{
                                    paddingTop: '9px',
                                    textAlign: 'center'
                                }}
                            >
                                {res().sampleForm.back}
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    )
})

export default FormPresentation
